module.exports = __webpack_public_path__ + "img/howtobuyeggs.3299074a.gif";